import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Check = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M3.5 7.5L6.5 10.5L12.5 4.5" stroke={color} />
    </svg>
  ),
)

Check.displayName = 'Check'

Check.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default Check
